import type { OrgAppConnectionPayload, RExternalOrgApp } from 'v2/types/api/settings'

export interface ExternalAppRow extends RExternalOrgApp {
  [key: string]: unknown
  isGroup: boolean
  subRows?: ExternalAppRow[]
}

// The chosen action sets the new state: `state` can arrive lowercase, so re-reading it here
// would turn a Disable the menu offered into a re-enable.
export const toolStateUpdate = (
  action: 'enable' | 'disable',
  app: ExternalAppRow,
): OrgAppConnectionPayload => ({
  app_uuid: app.id,
  connection_details: app.connection_details,
  enabled: action === 'enable',
  priority_order: app.priority,
})
